var exports = {
  "iE": "xaee3c4fa--9ed826--wrapper",
  "UU": "xaee3c4fa--9ed826--name",
  "et": "xaee3c4fa--9ed826--transport",
  "bB": "xaee3c4fa--9ed826--_ellipsis",
  "su": "xaee3c4fa--9ed826--icon-wrapper",
  "gO": "xaee3c4fa--9ed826--ellipsis",
};

module.exports = exports;
